exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pagination[data-v-75f448ce] {\n  text-align: right;\n  margin-top: 20px;\n}\n", ""]);

// exports
